export enum SubscriptionTerm {
    monthly = 'Monthly',
    annual = 'Annual',
    triennial = 'Triennial',
}
